import * as React from 'react';
import { forwardRef } from 'react';

import { useTheme } from '@volkswagen-onehub/components-core';
import styled from 'styled-components';

import translate from '../../../utils/translate';

import { ArrowLeft } from './arrows';
import { ArrowRight } from './arrows';
import { Label } from './label';
import { Overlay } from './overlay.wrapper';
import { WrapperMixin } from './wrapper.mixin';

interface DesktopOnboardingProps {
	handleClick: () => void;
}

export const DesktopOnboarding = forwardRef<HTMLDivElement, DesktopOnboardingProps>(({ handleClick }, ref) => {
	const { direction } = useTheme();
	const isLTR = direction === 'ltr';

	const RenderArrowLeft = isLTR ? ArrowLeft : ArrowRight;
	const RenderArrowRight = isLTR ? ArrowRight : ArrowLeft;

	return (
		<Overlay ref={ref} onClick={handleClick}>
			<Wrapper aria-label={translate('global.ariaLabel.tapToInteract')}>
				<RenderArrowLeft />
				<Label>{translate('onboarding.dragLeftRight')}</Label>
				<RenderArrowRight />
			</Wrapper>
		</Overlay>
	);
});

DesktopOnboarding.displayName = 'Desktop Onboarding';

const Wrapper = styled.button`
	display: flex;

	border: none;
	cursor: pointer;
	outline: none;

	&:focus {
		outline: rgb(76, 199, 244) solid 4px;
	}

	// Color of text
	* {
		color: rgb(255, 255, 255) !important;
	}

	// Color of background
	background-color: ${({ theme }) => theme.colors.grey400}; !important;
	${WrapperMixin()}
`;
